import { P as h, t as O, i as y, N as E, _ as p, Q as g } from "./export-cdcbfb2b.js";
import { a as $ } from "./array-method-is-strict-e5a3c878.js";
import { e as b } from "./environment-is-node-a035d787.js";
var w = h, C = O, M = y, j = E, u = TypeError, l = "Reduce of empty array with no initial value", s = function(e) {
  return function(o, a, d, t) {
    var v = C(o), i = M(v), n = j(v);
    if (w(a), n === 0 && d < 2)
      throw new u(l);
    var r = e ? n - 1 : 0, f = e ? -1 : 1;
    if (d < 2)
      for (; ; ) {
        if (r in i) {
          t = i[r], r += f;
          break;
        }
        if (r += f, e ? r < 0 : n <= r)
          throw new u(l);
      }
    for (; e ? r >= 0 : n > r; r += f)
      r in i && (t = a(t, i[r], r, v));
    return t;
  };
}, m = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: s(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: s(!0)
}, x = p, N = m.left, R = $, c = g, A = b, D = !A && c > 79 && c < 83, V = D || !R("reduce");
x({ target: "Array", proto: !0, forced: V }, {
  reduce: function(o) {
    var a = arguments.length;
    return N(this, o, a, a > 1 ? arguments[1] : void 0);
  }
});
